import { IPersonalAddressGetData, IPersonalAddressState } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const UpdateMfePersonalAddress = createAction(
  '[MFE Personal Address] Update Personal Address',
  props<{ payload: IPersonalAddressState }>(),
);

export const UpdateMfePersonalAddressValidationStatus = createAction(
  '[MFE Personal Address] Update Validation Status',
  props<{ payload: string }>(),
);

export const UpdateMfePersonalAddressFromGetData = createAction(
  '[MFE Personal Address] Update From Get Data',
  props<{ payload: IPersonalAddressGetData }>(),
);

export const UpdateMfePersonalAddressIsContinueConfirmed = createAction(
  '[MFE Personal Address] Update Is Continue Confirmed',
  props<{ payload: boolean }>(),
);

export const ResetMfePersonalAddress = createAction(
  '[MFE Personal Address] Reset Personal Address',
);
